import { gql } from 'graphql-request';
import type { GqlSonCategoryScore } from 'src/app/portfolio/state/api/portfolioStateOfNatureQuery';

export type GqlSonFactor = {
    sourceKey: string;
    name: string;
    band: 'VERY_GOOD' | 'GOOD' | 'MODERATE' | 'POOR' | 'VERY_POOR';
    weight: number;
};

export type GqlSiteSonCategoryScore = Omit<GqlSonCategoryScore, 'factors'> & {
    factors: GqlSonFactor[];
};

export const siteStateOfNatureQuery = gql`
    query GetSiteStateOfNature($organisationBusinessCentralId: String!, $siteId: ID!) {
        site(organisationBusinessCentralId: $organisationBusinessCentralId, siteId: $siteId) {
            id
            name
            riskSummary {
                stateOfNature
            }
            sonCategoryBreakdown {
                sourceKey
                name
                score
                band
                factors {
                    sourceKey
                    name
                    band
                    weight
                }
            }
        }
    }
`;

export type SiteStateOfNatureResult = {
    site: {
        id: string;
        name: string;
        riskSummary: {
            stateOfNature: number | null;
        } | null;
        sonCategoryBreakdown: GqlSiteSonCategoryScore[];
    } | null;
};
